import { z } from 'zod';

export const InboundNfConferenceStatusSchema = z.enum(['OPEN', 'FINALIZED', 'CANCELLED']);
export const InboundNfLineMatchStatusSchema = z.enum(['UNMATCHED', 'MATCHED']);
export const InboundNfLineConferenceStatusSchema = z.enum(['AWAITING', 'CONFERENCED']);

export const InboundNfConferenceLineSchema = z.object({
  id: z.uuid(),
  lineNumber: z.number().int().positive(),
  productCode: z.string().nullable(),
  productDescription: z.string().nullable(),
  barcode: z.string().nullable(),
  brandName: z.string().nullable(),
  manufacturerCode: z.string().nullable(),
  ncmCode: z.string().nullable(),
  quantityBp: z.string().regex(/^[1-9]\d*$/),
  unitCostCents: z.string().regex(/^\d+$/),
  tenantProductId: z.uuid().nullable(),
  matchStep: z.enum(['SKU', 'SUPPLIER_SKU', 'EAN', 'BRAND_MPN', 'GENERIC']).nullable(),
  matchStatus: InboundNfLineMatchStatusSchema,
  conferenceStatus: InboundNfLineConferenceStatusSchema,
  storageId: z.uuid().nullable(),
  stockLotId: z.uuid().nullable(),
  conferencedAt: z.iso.datetime().nullable(),
});

export const InboundNfConferenceSchema = z.object({
  id: z.uuid(),
  placeId: z.uuid(),
  fiscalDocumentId: z.uuid(),
  supplierRoleId: z.uuid(),
  status: InboundNfConferenceStatusSchema,
  finalizedAt: z.iso.datetime().nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
  lines: z.array(InboundNfConferenceLineSchema),
});

export const ListInboundNfConferencesQuerySchema = z.object({
  placeId: z.uuid(),
});

export const ListInboundNfConferencesResponseSchema = z.object({
  items: z.array(InboundNfConferenceSchema),
});

export const ConferenceInboundNfLineBodySchema = z.object({
  storageId: z.uuid(),
  quantityBp: z.string().regex(/^[1-9]\d*$/),
  lotCode: z.string().trim().min(1).max(50).optional(),
});

export const ConferenceInboundNfLineResponseSchema = z.object({
  conferenceId: z.uuid(),
  lineId: z.uuid(),
  stockLotId: z.uuid(),
  complete: z.boolean(),
});

export const RematchInboundNfConferenceResponseSchema = z.object({
  matchedCount: z.number().int().nonnegative(),
  unmatchedCount: z.number().int().nonnegative(),
});

export const InboundNfConferenceCompletionResponseSchema = z.object({
  conferenceId: z.uuid(),
  complete: z.boolean(),
  unmatchedCount: z.number().int().nonnegative(),
  awaitingCount: z.number().int().nonnegative(),
});

export type InboundNfConference = z.infer<typeof InboundNfConferenceSchema>;
export type ListInboundNfConferencesQuery = z.infer<typeof ListInboundNfConferencesQuerySchema>;
export type ListInboundNfConferencesResponse = z.infer<
  typeof ListInboundNfConferencesResponseSchema
>;
export type ConferenceInboundNfLineBody = z.infer<typeof ConferenceInboundNfLineBodySchema>;
export type ConferenceInboundNfLineResponse = z.infer<typeof ConferenceInboundNfLineResponseSchema>;
export type RematchInboundNfConferenceResponse = z.infer<
  typeof RematchInboundNfConferenceResponseSchema
>;
export type InboundNfConferenceCompletionResponse = z.infer<
  typeof InboundNfConferenceCompletionResponseSchema
>;
